import { Padder, Spacer, Text } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import styles from './ViewOnlyDetail.module.css';

export const ViewOnlyDetail = () => {
  const { getTranslation } = useTranslate();

  return (
    <Spacer vertical={Padder.Size.M}>
      <Padder all={Padder.Size.M} className={styles.border}>
        <table>
          <tr className={styles.header}>
            <td colSpan={2}>
              <Text
                className={styles.text}
                textStyle={Text.Style.BodyMdSemibold}
              >
                {getTranslation('add_child_only_view_available_features')}
              </Text>
            </td>
          </tr>
          <tr>
            <td className={styles.feature}>
              <img alt="check" className={styles.icon} src="/icons/check.svg" />
              <Text
                className={styles.text}
                textStyle={Text.Style.BodyMdRegular}
              >
                {getTranslation('add_child_only_view_available_features_2')}
              </Text>
            </td>
            <td className={styles.feature}>
              <img alt="check" className={styles.icon} src="/icons/check.svg" />
              <Text
                className={styles.text}
                textStyle={Text.Style.BodyMdRegular}
              >
                {getTranslation('add_child_only_view_available_features_3')}
              </Text>
            </td>
          </tr>
          <tr>
            <td className={styles.feature}>
              <img alt="check" className={styles.icon} src="/icons/check.svg" />
              <Text textStyle={Text.Style.BodyMdRegular}>
                {getTranslation('add_child_only_view_available_features_4')}
              </Text>
            </td>
            <td className={styles.feature}>
              <Text
                className={styles.text}
                textStyle={Text.Style.BodyMdRegular}
              >
                <img
                  alt="check"
                  className={styles.icon}
                  src="/icons/check.svg"
                />
                {getTranslation('add_child_only_view_available_features_5')}
              </Text>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <div className={styles.divider} />
            </td>
          </tr>
          <tr className={styles.header}>
            <td colSpan={2}>
              <Text
                className={styles.text}
                textStyle={Text.Style.BodyMdSemibold}
              >
                {getTranslation('add_child_only_view_unavailable_features')}
              </Text>
            </td>
          </tr>
          <tr>
            <td className={styles.feature}>
              <img alt="cross" className={styles.icon} src="/icons/cross.svg" />
              <Text
                className={styles.text}
                textStyle={Text.Style.BodyMdRegular}
              >
                {getTranslation('add_child_only_view_unavailable_features_1')}
              </Text>
            </td>
            <td className={styles.feature}>
              <img alt="cross" className={styles.icon} src="/icons/cross.svg" />
              <Text
                className={styles.text}
                textStyle={Text.Style.BodyMdRegular}
              >
                {getTranslation('add_child_only_view_unavailable_features_2')}
              </Text>
            </td>
          </tr>
          <tr>
            <td className={styles.feature}>
              <img alt="cross" className={styles.icon} src="/icons/cross.svg" />
              <Text
                className={styles.text}
                textStyle={Text.Style.BodyMdRegular}
              >
                {getTranslation('add_child_only_view_unavailable_features_3')}
              </Text>
            </td>
          </tr>
          <tr>
            <td className={styles.feature} colSpan={2}>
              <img alt="cross" className={styles.icon} src="/icons/cross.svg" />
              <Text
                className={styles.text}
                textStyle={Text.Style.BodyMdRegular}
              >
                {getTranslation('add_child_only_view_unavailable_features_4')}
              </Text>
            </td>
          </tr>
        </table>
      </Padder>
    </Spacer>
  );
};
